import { Badge } from '@shared/components/ui/badge/Badge';
import { useTranslation } from 'react-i18next';
import type { ShipmentStatusMapping } from '../../models/shipmentStatusMapping.types';

interface ExternalStatusCardProps {
  mapping: ShipmentStatusMapping;
}

export const ExternalStatusCard = ({ mapping }: ExternalStatusCardProps) => {
  const { t } = useTranslation('shipmentStatusMappingModule');

  return (
    <div className="space-y-3 rounded-lg border border-card-border bg-card-bg p-4">
      <div className="flex items-start justify-between gap-3">
        <h3 className="text-sm font-medium text-title">{t('shipmentStatusMapping.modal.externalStatus')}</h3>
        <Badge variant="outline" className="shrink-0 border-0 bg-card-border text-text">
          {mapping.courier.name}
        </Badge>
      </div>

      <div className="space-y-3 text-sm">
        <div>
          <span className="mb-1 block text-subtext">{t('shipmentStatusMapping.modal.statusDescription')}</span>
          <p className="font-medium leading-relaxed text-text">{mapping.status_description}</p>
        </div>
      </div>
    </div>
  );
};
